/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prettier/prettier */

import React, { useState, useEffect, useRef } from 'react';
import { getFromLocalStorage } from '../../components/helper/authorizationHelper';
import { postAsync } from '../../components/helper/axiosHelper';
import Loader from '../../components/Loader/Loader';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DataNotFound } from '../../components/DataNotFound';
import { Stack } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';

const UserDashboardCard = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [lowerSelectedButton, setlowerSelectedButton] = useState('User Profile Status');
  const [lowerSelectedTab, setlowerSelectedTab] = useState(10);
  const [epUserID, setEpUserID] = useState(null);
  const [serviceCardData, setServiceCardData] = useState([]);
  const [gwaProjectData, setGwaProjectData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [sdReportData, setSdReportData] = useState([]);
  const [isload, setIsLoad] = useState(false);
  const [authenticationData, setAuthenticationData] = useState([]);
  const [serviceForYouData, setServiceForYouData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 8,
  });

  const { t } = useTranslation();

  // new codee
  const tabContainerRef = useRef(null);

  useEffect(() => {
    if (tabContainerRef.current) {
      const isRtl = window.getComputedStyle(tabContainerRef.current).direction === 'rtl';
      const scrollAmount = isRtl ? tabContainerRef.current.scrollWidth : 0;
      tabContainerRef.current.scrollTo({
        left: scrollAmount,
        behavior: 'smooth',
      });
    }
  }, []);

  // Card tab function
  const handleCardTabClick = (buttonName, id) => {
    setlowerSelectedButton(buttonName);
    setlowerSelectedTab(id);
 // Reset pagination when switching tabs
    setPageOptions(prev => ({ ...prev, pageNo: 1 }));
    setCurrentPage(1);
    setHasMore(true);
    // Handle specific tab actions
    if (id === 6) {
      gwaAndVolunteer();
    }
    if (id === 7) {
      gwaProject();
    }
    if (id === 8) {
      gwaPayment();
    }
    if (id === 9) {
      sdReportList();
    }
    if (id === 10) {
      userAuthentication();
    }
    if (id === 11) {
      serviceForYou();
    }
  };

  const cardTabs = [
    {
      tabName: 'User Profile Status',
      id: 10,
    },
    {
      tabName: 'Service Status',
      id: 6,
    },
    {
      tabName: 'Campaign Status',
      id: 7,
    },
    {
      tabName: 'GWA Project Status',
      id: 8,
    },
    {
      tabName: 'SD Project Status',
      id: 9,
    },
    {
      tabName: 'SU Project Status',
      id: 11,
    },
  ];

  useEffect(() => {
    localStorage.setItem('isHome', false);

    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID !== null) {
      userAuthentication();
      gwaAndVolunteer();
    }
  }, [epUserID]);
// useEffect(() => {
//     localStorage.setItem('isHome', false);

//     const retrievedData = getFromLocalStorage('upid');
//     retrievedData
//       ?.then((res) => {
//         setEpUserID(res);
//       })
//       .catch((err) => {
//         console.log('data', err);
//       });
//   }, []);

//   // Load initial data when epUserID is available
//   useEffect(() => {
//     if (epUserID !== null) {
//       userAuthentication();
//       gwaAndVolunteer();
//     }
//   }, [epUserID]);
  const gwaAndVolunteer = async () => {
    setIsLoad(true);
    try {
      const res = await postAsync('Utilities/EPUserServiceCheck', {}, { id: epUserID });
      // console.log("data Updated", res);
      setServiceCardData(res);
      setIsLoad(false);
    } catch (error) {
      setIsLoad(false);
      console.error('Error updating data:', error);
    }
  };

  const gwaProject = async () => {
    setPageOptions((prev) => ({
      ...prev,
      pageNo: 1,
    }));
    setIsLoad(true);
    try {
      const res = await postAsync(
        `Campaign/GetCampaignReportFilterListByUserID/1/${pageOptions.pageSize}`,
        { epUsername: null, campaignName: null },
        { id: epUserID },
      );
      if (res.data !== 0 || res.data !== null) {
        setGwaProjectData(res.data);
        setIsLoad(false);
        setPageCount(res.page);
        setCurrentPage(res.currentPage);
        // setIsLoad(false)
        // console.log("res data", res.data);
        // console.log("gwaProjectData", gwaProjectData);
      }
      // console.log("gwaProjectData is not set", gwaProjectData);
    } catch (error) {
      setIsLoad(false);
      console.error('Error updating data:', error);
    }
  };

  const gwaPayment = async () => {
    setIsLoad(true);
    try {
      const res = await postAsync(
        `GWAProject/GetGWAReportFilterListByUserID/1/${pageOptions.pageSize}`,
        {},
        { id: epUserID },
      );
      if (res.data.length > 0 || res.data.length !== null) {
        setPaymentData(res.data);
        setIsLoad(false);
        setPageCount(res.page);
        setCurrentPage(res.currentPage);
      }
    } catch (error) {
      setIsLoad(false);
      console.error('Error updating data:', error);
    }
  };

  const sdReportList = async () => {
    setPageOptions((prev) => ({
      ...prev,
      pageNo: 1,
    }));
    setIsLoad(true);
    try {
      const res = await postAsync(
        `ServiceDead/GetSDReportListByUserID/1/${pageOptions.pageSize}`,
        {},
        { id: epUserID },
      );
      setSdReportData(res.data);
      setIsLoad(false);
      setPageCount(res.page);
      setCurrentPage(res.currentPage);
    } catch (error) {
      setIsLoad(false);
      console.error('Error updating data:', error);
    }
  };

  const userAuthentication = async () => {
    setIsLoad(true);
    try {
      const res = await postAsync('EP_UserAuthentication/GetEPUserprofilereportByUserId', {}, { id: epUserID });

      setAuthenticationData(res.data);
      setIsLoad(false);
      // console.log("sd Response", serv)
    } catch (error) {
      setIsLoad(false);
      console.error('Error updating data:', error);
    }
  };

  const serviceForYou = async () => {
  setPageOptions((prev) => ({
    ...prev,
    pageNo: 1,
  }));
    setIsLoad(true);
    try {
      const res = await postAsync(
        `ServiceForYou/GetServiceForYouReportFilterListByUserID/1/${pageOptions.pageSize}`,
        {},
        { id: epUserID },
      );
      setServiceForYouData(res.data);
      setIsLoad(false);
      setPageCount(res.page);
      setCurrentPage(res.currentPage);
      // console.log("sd Response", serv)
    } catch (error) {
      setIsLoad(false);
      console.error('Error updating data:', error);
    }
  };
  const fetchData = async (url, id) => {
    const newPage = pageOptions.pageNo + 1;

    try {
      setPageOptions((prev) => ({
        ...prev,
        pageNo: prev.pageNo + 1,
      }));
      const response = await postAsync(`${url}/${newPage}/${pageOptions.pageSize}`, {}, { id: epUserID });
      const newData = response?.data || [];
      if (id == 8) {
        setPaymentData((prevData) => [...prevData, ...newData]);
        setCurrentPage(response.currentPage);
      } else if (id == 7) {
        setGwaProjectData((prevData) => [...prevData, ...newData]);
        setCurrentPage(response.currentPage);
      }
      else if (id == 9) {
        setSdReportData((prevData) => [...prevData, ...newData]);
        setCurrentPage(response.currentPage);
      }
      else if (id == 11) {
        setServiceForYouData((prevData) => [...prevData, ...newData]);
        setCurrentPage(response.currentPage);
      }
    } catch (error) {
      console.error(t('Something went wrong, Please try again!'));
      setHasMore(false);
    }
  };

  return (
    <div className="flex   pb-10  w-full flex-col">
      <div className="text-lg mt-1 bg-white lg:px-12 font-medium text-center text-gray-500 border-b rounded-lg border-gray-50 dark:text-gray-400">
        {/* new codde */}
        <div className="flex justify-center">
          <Stack
            direction="row"
            sx={{
              overflowY: 'auto',
              height: 'auto',
              flexDirection: 'row', // Always set to row
              whiteSpace: 'nowrap', // Prevent text from wrapping to the next line
              '&::-webkit-scrollbar': {
                width: '8px', // Adjust width for WebKit browsers
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent', // Background of the track set to transparent
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#047857', // Color of the scrollbar thumb set to customgreen
                borderRadius: '10px', // Rounded corners for the thumb
              },
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: '#047857 transparent', // For Firefox: thumb color and track color
            }}
          >
            {cardTabs.map((category) => (
              // <button
              //   key={category.tabName}
              //   onClick={() => handleCardTabClick(category.tabName, category.id)}
              //   className={`inline-block my-2 mx-1 px-2 active bg-gray-100 hover:text-gray-600 border-gray-300 transition-colors text-customgreen hover:border-customgreen rounded-t-lg py-1 sm:px-4 max-[638px]:text-sm text-lg max-[638px]:px-2 font-medium text-center ${
              //     lowerSelectedTab === category.id
              //       ? 'bg-gray-200 border-customgreen border-t-8'
              //       : 'bg-gray-100 text-gray-800'
              //   }`}
              // >
              <button
                key={category.tabName}
                onClick={() => handleCardTabClick(category.tabName, category.id)}
                className={`inline-block my-2 mx-1 px-2 active bg-gray-100 hover:text-gray-600 border-gray-300 transition-colors text-customgreen hover:border-[#06703A] rounded-t-lg py-1 sm:px-4 max-[638px]:text-sm text-lg max-[638px]:px-2 font-medium text-center ${
                  lowerSelectedTab === category.id
                    ? 'bg-gray-200 border-green-700 border-t-8'
                    : 'bg-gray-100 text-gray-800'
                }`}
              >
                {t(category.tabName)}
              </button>
            ))}
          </Stack>
        </div>
        {/* new codde ends */}

        {/* Lower Tabs */}
        {/* <div
        ref={tabContainerRef}
        className="flex gap-2   justify-center whitespace-nowrap flex-wrap"
        style={{
          scrollbarWidth: 'thin', // For Firefox
          paddingBottom: '10px',  // Adjust the margin below the scrollbar
        }}
      >
        {cardTabs.map((item) => {
          const { tabName, id } = item;
          return (
            <button
              key={id}
              className={`inline-block px-2 active bg-gray-100 hover:text-gray-600 border-gray-300 transition-colors text-customgreen hover:border-customgreen rounded-t-lg py-1 sm:px-4 max-[638px]:text-sm text-lg max-[638px]:px-2 font-medium text-center ${
                lowerSelectedButton === tabName
                  ? 'bg-gray-200 border-customgreen border-t-8'
                  : 'bg-gray-100 text-gray-800'
              }`}
              onClick={() => handleCardTabClick(tabName, id)}
              id={id} // Ensure each tab has a unique ID
            >
              {t(tabName)}
            </button>
          );
        })}
      </div> */}
      </div>

      {/* <div className="grid grid-cols-1 sm:grid-cols-2 bg-haka justify-center items-center lg:grid-cols-3 xl:grid-cols-4 gap-2"> */}
      <div className="flex flex-col sm:flex-row my-3 md:flex-row lg:flex-row  xl:flex-row xl:px-5 flex-wrap justify-center items-center gap-x-4 gap-y-5">
        {(lowerSelectedTab == 6 &&
          (isload ? (
            <div className="flex justify-center">
              <Loader />
            </div>
          ) : (
            <>
              <div className="w-64 sm:w-64 max-w-[380px] bg-gradient-to-b from-customgreen to-customorange h-44 rounded-lg shadow-2xl p-4 flex flex-col justify-center">
                <div className="flex justify-between items-center">
                  <div className="text-white flex items-center">
                    <p className="text-sm font-bold">{`${t('GWA Service Status')}`}</p>
                  </div>
                  <div>
                    <svg
                      className="w-6 h-6 text-white dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 4.5V19a1 1 0 0 0 1 1h15M7 14l4-4 4 4 5-5m0 0h-3.207M20 9v3.207"
                      />
                    </svg>
                  </div>
                </div>
                <div className="text-white text-center">
                  {/* <p class="text-xs">Price of Project</p> */}
                  <p className="text-xl">
                    {serviceCardData?.gwaServiceRegistered === 0
                      ? t('Pending')
                      : serviceCardData?.gwaServiceRegistered === 1
                        ? t('Approved and Activated')
                        : serviceCardData?.gwaServiceRegistered === 2
                          ? t('Approved but Deactivated')
                          : serviceCardData?.gwaServiceRegistered === 3
                            ? t('User Disapproved')
                            : serviceCardData?.gwaServiceRegistered === 4
                              ? t('Not Registered')
                              : t('Unknown Status')}
                  </p>
                </div>
                <div className="flex justify-between items-center"></div>
              </div>

              {/* Second card */}

              <div className="w-64 sm:w-64 max-w-[380px] bg-gradient-to-b from-customgreen to-customorange h-44 rounded-lg shadow-2xl p-4 flex flex-col gap-3 justify-center">
                <div className="flex justify-between items-center">
                  <div className="text-white flex items-center">
                    <p className="text-sm font-bold">{t('Volunteer Service Status')}</p>
                  </div>
                  <div>
                    <svg
                      className="w-6 h-6 text-white dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 4.5V19a1 1 0 0 0 1 1h15M7 14l4-4 4 4 5-5m0 0h-3.207M20 9v3.207"
                      />
                    </svg>
                  </div>
                </div>
                <div className="text-white text-center">
                  {/* <p class="text-xs">Price of Project</p> */}
                  <p className="text-xl">
                    {serviceCardData?.volunteerServiceRegistered == 0
                      ? t('Not Registered as Volunteer')
                      : serviceCardData?.volunteerServiceRegistered == 1
                        ? t('Registered as Volunteer')
                        : t('No data')}
                  </p>
                </div>
                <div className="flex justify-between items-center"></div>
              </div>
            </>
          ))) ||
          (lowerSelectedTab == 7 &&
            (isload ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : (
              <>
                {gwaProjectData?.length > 0 ? (
                  <InfiniteScroll
                    dataLength={paymentData?.length}
                    next={
                      currentPage === pageCount
                        ? () => {}
                        : () => {
                            fetchData('Campaign/GetCampaignReportFilterListByUserID', 7);
                          }
                    }
                    hasMore={hasMore}
                    loader={
                      currentPage === pageCount ? null : (
                        <div className="flex justify-center">
                          <Loader />
                        </div>
                      )
                    }
                  >
                    <>
                      <div className="flex flex-col sm:flex-row my-3 md:flex-row lg:flex-row  xl:flex-row xl:px-5 flex-wrap justify-center items-center gap-x-4 gap-y-5">
                        {gwaProjectData?.map((project, index) => {
                          return (
                            <div
                              key={index}
                              className="w-64 sm:w-64 max-w-[380px] bg-gradient-to-b from-customgreen to-customorange h-44 rounded-lg shadow-2xl p-4 flex flex-col gap-3 justify-center"
                            >
                              <div>
                                <h1 className="text-white font-bold">
                                  {project.campaignName ? `${t(project.campaignName)}` : t('No Campaign Name')}
                                </h1>
                              </div>
                              <div className="flex my-4">
                                <h1 className="text-white font-bold">{t('Total Visited Count')}: &nbsp;</h1>
                                <h1 className="text-white">{project.hitCount ? project.hitCount : '0'}</h1>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  </InfiniteScroll>
                ) : (
                  <DataNotFound />
                )}
              </>
            ))) ||
          (lowerSelectedTab == 8 &&
            (isload ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : (
              <>
                {paymentData?.length > 0 ? (
                  <>
                    <InfiniteScroll
                      dataLength={paymentData?.length}
                      next={
                        currentPage === pageCount
                          ? () => {}
                          : () => {
                              fetchData('GWAProject/GetGWAReportFilterListByUserID', 8);
                            }
                      }
                      hasMore={hasMore}
                      loader={
                        currentPage === pageCount ? null : (
                          <div className="flex justify-center">
                            <Loader />
                          </div>
                        )
                      }
                    >
                      <div className="flex flex-col sm:flex-row my-3 md:flex-row lg:flex-row  xl:flex-row xl:px-5 flex-wrap justify-center items-center gap-x-4 gap-y-5">
                        {paymentData.map((payment, index) => {
                          return (
                            <div
                              key={index}
                              className="w-64 sm:w-64 max-w-[380px] bg-gradient-to-b from-customgreen to-customorange h-44 rounded-lg shadow-2xl p-4 flex flex-col gap-3 justify-center"
                            >
                              <div className="flex">
                                {/* <h1 className="text-white font-bold">{t('Project Name')}: &nbsp;</h1> */}
                                <h1 className="text-white  font-bold">
                                  {isActive ? payment.projectNameAr : payment.projectNameAr}
                                </h1>
                              </div>
                              <div className="flex">
                                <h1 className="text-white font-bold">{t('Donated Amount')}: &nbsp;</h1>
                                <h1 className="text-white mx-2">{payment.donatedAmount}</h1>
                              </div>
                              <div className="flex">
                                <h1 className="text-white font-bold">{t('Total Payment Count')}: &nbsp;</h1>
                                <h1 className="text-white">{payment.totalPaymentCount}</h1>
                              </div>
                              <div className="flex">
                                <h1 className="text-white font-bold">{t('Total Visited Count')}: &nbsp;</h1>
                                <h1 className="text-white">{payment.totalVisitedCount}</h1>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </InfiniteScroll>
                  </>
                ) : (
                  <DataNotFound />
                )}
              </>
            ))) ||
          (lowerSelectedTab == 9 &&
            (
          isload ? (
            <div className="flex justify-center">
              <Loader />
            </div>
          ) : (
            sdReportData?.length > 0 ? (
              <InfiniteScroll
                dataLength={sdReportData.length}
                next={() => fetchData('ServiceDead/GetSDReportListByUserID', 9)}
                hasMore={hasMore}
                loader={currentPage < pageCount && <div className="flex justify-center"><Loader /></div>}
              >
                <div className="flex flex-col sm:flex-row my-3 md:flex-row lg:flex-row xl:flex-row xl:px-5 flex-wrap justify-center items-center gap-x-4 gap-y-5">
                  {sdReportData.map((sdData, index) => (
                    <div key={index} className="w-64 sm:w-64 max-w-[380px] bg-gradient-to-b from-customgreen to-customorange h-44 rounded-lg shadow-2xl p-4 flex flex-col gap-3 justify-center">
                      <div className="flex">
                        <h1 className="text-white font-bold">
                          {isActive ? sdData.projectNameAr : sdData.projectNameAr}
                        </h1>
                      </div>
                      <div className="flex">
                        <h1 className="text-white font-bold">{t('Donated Amount')}: &nbsp;</h1>
                        <h1 className="text-white mx-2">{sdData.donatedAmount}</h1>
                      </div>
                      <div className="flex">
                        <h1 className="text-white font-bold">{t('Total Payment Count')}: &nbsp;</h1>
                        <h1 className="text-white">{sdData.totalPaymentCount}</h1>
                      </div>
                      <div className="flex">
                        <h1 className="text-white font-bold">{t('Total Visited Count')}: &nbsp;</h1>
                        <h1 className="text-white">{sdData.totalVisitedCount}</h1>
                      </div>
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            ) : (
              <DataNotFound />
            )
          )
        )) ||
          (lowerSelectedTab == 10 &&
            (isload ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : (
              <>
                {authenticationData?.length > 0 ? (
                  <>
                    {authenticationData.map((authData, index) => {
                      return (
                        <div
                          key={index}
                          className="w-64 sm:w-64 max-w-[380px] bg-gradient-to-b from-customgreen to-customorange h-44 rounded-lg shadow-2xl p-4 flex flex-col gap-3 justify-center"
                        >
                          <div className="flex ">
                            <h1 className="text-white font-bold">{t('Full Name')}: &nbsp;</h1>
                            <h1 className="text-white ">{authData.fullName ? authData.fullName : t('no name')}</h1>
                          </div>
                          <div className="flex">
                            <h1 className="text-white font-bold">{t('Username')}: &nbsp;</h1>
                            <h1 className="text-white ">{authData.userName}</h1>
                          </div>

                          <div className="flex">
                            <h1 className="text-white font-bold">{t('Total Visited Count')}: &nbsp;</h1>
                            <h1 className="text-white ">{authData.hitCount ? authData.hitCount : '0'}</h1>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <DataNotFound />
                )}
              </>
            ))) ||
          (lowerSelectedTab == 11 &&
           (
          isload ? (
            <div className="flex justify-center">
              <Loader />
            </div>
          ) : (
            serviceForYouData?.length > 0 ? (
              <InfiniteScroll
                dataLength={serviceForYouData.length}
                next={() => fetchData('ServiceForYou/GetServiceForYouReportFilterListByUserID', 11)}
                hasMore={hasMore}
                loader={currentPage < pageCount && <div className="flex justify-center"><Loader /></div>}
              >
                <div className="flex flex-col sm:flex-row my-3 md:flex-row lg:flex-row xl:flex-row xl:px-5 flex-wrap justify-center items-center gap-x-4 gap-y-5">
                  {serviceForYouData.map((suData, index) => (
                    <div key={index} className="w-64 sm:w-64 max-w-[380px] bg-gradient-to-b from-customgreen to-customorange h-44 rounded-lg shadow-2xl p-4 flex flex-col gap-3 justify-center">
                      <div className="flex">
                        <h1 className="text-white font-bold">
                          {isActive ? suData.projectNameAr : suData.projectNameAr}
                        </h1>
                      </div>
                      <div className="flex">
                        <h1 className="text-white font-bold">{t('Donated Amount')}: &nbsp;</h1>
                        <h1 className="text-white">{suData.donatedAmount}</h1>
                      </div>
                      <div className="flex">
                        <h1 className="text-white font-bold">{t('Total Payment Count')}: &nbsp;</h1>
                        <h1 className="text-white">{suData.totalPaymentCount}</h1>
                      </div>
                      <div className="flex">
                        <h1 className="text-white font-bold">{t('Total Visited Count')}: &nbsp;</h1>
                        <h1 className="text-white mx-2">{suData.totalVisitedCount}</h1>
                      </div>
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            ) : (
              <DataNotFound />
            )
          )
        ))}
      </div>
    </div>
  );
};

export default UserDashboardCard;
